import { logError as dnaErrorLogger } from 'dna-core/components/utils/js/errors';

export const logError = (err, _dnaErrorLogger = dnaErrorLogger) => {
	let error = new Error('Cannot find the cause of error');

	if (err instanceof Error || err instanceof TypeError) {
		error = err;
	} else {
		error.message = (err && err.message) || error.message;
	}
	_dnaErrorLogger(error);
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/utils/logError.js